module.exports = __webpack_public_path__ + "./img/help.10bb180857df7c05650a02ba15c5d77b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/help.png
// module id = ./assets/images/help.png
// module chunks = 0